import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerContent = styled.div`
  padding: 24px 0px;
`;
